export enum EScheduleListType {
    Planner,
    Posted,
    Master,
    JobSchedule,
    ClientSchedule
}